import doenerCase from "scripts/doenerCase"

export const create_keyword_string = ({
  tags = [],
  ressort = "",
  topic = "",
}) =>
  `topic_${ressort}_${doenerCase(topic)}` +
  (!!tags?.[0] ? "," + tags.map(({ slug }) => `tag_${slug}`)?.join(",") : "")
